import { render, staticRenderFns } from "./Hospitals.vue?vue&type=template&id=208fbb46&scoped=true"
import script from "./Hospitals.vue?vue&type=script&lang=js"
export * from "./Hospitals.vue?vue&type=script&lang=js"
import style0 from "./Hospitals.vue?vue&type=style&index=0&id=208fbb46&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "208fbb46",
  null
  
)

export default component.exports